import { useTranslation } from 'react-i18next'
import { MenuItem, Typography } from '@mui/material'
import { GenderEnum } from '@/enums'

import InputFormikField from '@/views/components/input-formik-field/index.component'

export const GenderPersonalInfo = () => {
  const { t } = useTranslation()

  const genders = Object.values(GenderEnum).map((gender) => {
    return (
      <MenuItem key={gender.toLowerCase()} value={gender.toLowerCase()}>
        <Typography variant="body2" sx={{ paddingLeft: 0.5 }}>
          {t(`gender.${gender.toUpperCase()}`)}
        </Typography>
      </MenuItem>
    )
  })

  return (
    <InputFormikField
      label={t('labels.gender')}
      name="gender"
      select
      sx={{
        '& .MuiSelect-select': {
          display: 'flex',
          maxHeight: '16px',
        },
      }}
    >
      {genders}
    </InputFormikField>
  )
}
